<script setup>
import { usePage } from "@inertiajs/vue3";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import { onBeforeUnmount, onMounted, ref, useSlots } from "vue";

const props = defineProps({
    active: {
        type: Boolean,
        required: false,
    },
});
const slots = useSlots();

const availableLanguages = usePage().props.availableLanguages;
const currentTenant = usePage().props.currentTenant;

const showDropdown = ref(false);
const dropdownId = `nav-button-${Math.random().toString(36).slice(2)}`;

function toggleDropdown() {
    showDropdown.value = !showDropdown.value;

    if (showDropdown.value) {
        window.dispatchEvent(new CustomEvent("navigation-dropdown-opened", { detail: dropdownId }));
    }
}

function closeWhenOtherDropdownOpens(event) {
    if (event.detail !== dropdownId) {
        showDropdown.value = false;
    }
}

onMounted(() => {
    window.addEventListener("navigation-dropdown-opened", closeWhenOtherDropdownOpens);
});

onBeforeUnmount(() => {
    window.removeEventListener("navigation-dropdown-opened", closeWhenOtherDropdownOpens);
});
</script>

<template>
    <li class="relative xl:h-[68px]">
        <div class="xl:h-[68px] flex items-center">
            <button
                @click="toggleDropdown"
                class="relative flex min-h-12 w-full items-center justify-start gap-4 rounded-xl px-3.5 py-3 text-gray-600 hover:bg-gray-50 hover:text-theme-primary transition-all duration-300 xl:size-10 xl:min-h-0 xl:w-10 xl:justify-center xl:gap-0 xl:border xl:border-gray-200 xl:bg-white xl:p-0 xl:text-gray-500 xl:hover:border-theme-primary"
                :class="active || showDropdown ? 'border-theme-primary text-theme-primary bg-theme-primary/5' : ''"
            >
                <slot name="menu" />
                <ChevronDownIcon
                    class="ml-auto size-5 transition-transform duration-300 xl:hidden"
                    :class="showDropdown ? 'rotate-180' : ''"
                />
            </button>
        </div>

        <transition>
            <div
                v-if="slots.dropdown && showDropdown"
                class="mt-2 block border-l border-gray-100 bg-white pl-3 xl:absolute xl:top-full xl:right-0 xl:mt-3 xl:w-56 xl:overflow-hidden xl:rounded-2xl xl:border xl:border-gray-100 xl:bg-white xl:px-2 xl:py-2 xl:pl-2 xl:shadow-xl"
            >
                <slot name="dropdown" />
            </div>
        </transition>
    </li>
</template>

<style scoped></style>
